import React, { useEffect, useState } from 'react';
import { CheckCircle, ShieldCheck } from 'lucide-react';
const names = ['Marco', 'Giulia', 'Alessandro', 'Francesca', 'Matteo', 'Chiara', 'Lorenzo', 'Silvia', 'Andrea', 'Elena', 'Valentina', 'Giuseppe', 'Sara', 'Luca', 'Anna'];
const cities = ['Roma', 'Milano', 'Napoli', 'Torino', 'Palermo', 'Genova', 'Bologna', 'Firenze', 'Bari', 'Catania', 'Verona', 'Padova', 'Trieste', 'Brescia', 'Parma'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchase, setPurchase] = useState({
    name: '',
    city: '',
    minutesAgo: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomMinutes = Math.floor(Math.random() * 12) + 1;
      setPurchase({
        name: randomName,
        city: randomCity,
        minutesAgo: randomMinutes
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(() => {
      showPopup();
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 15000) + 15000);
      return () => clearInterval(interval);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up max-w-sm w-[calc(100%-2rem)]" data-id="element-178">
      <div className="bg-white rounded-xl shadow-2xl p-4 flex items-center gap-4 border border-gray-200" data-id="element-179">
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-180">
          <CheckCircle className="w-7 h-7 text-green-600" data-id="element-181" />
        </div>
        <div className="flex-1" data-id="element-182">
          <p className="text-gray-800 text-sm" data-id="element-183">
            <span className="font-bold" data-id="element-184">{purchase.name}</span> da{' '}
            <span className="font-bold" data-id="element-185">{purchase.city}, Italia</span>
          </p>
          <p className="text-gray-500 text-xs mt-0.5" data-id="element-186">
            ha appena acquistato il MegaPack Inglese
          </p>
          <div className="flex items-center gap-3 mt-1.5" data-id="element-187">
            <div className="flex items-center gap-1" data-id="element-188">
              <ShieldCheck className="w-3 h-3 text-blue-600" data-id="element-189" />
              <span className="text-blue-600 text-xs font-medium" data-id="element-190">
                Verificato
              </span>
            </div>
            <span className="text-gray-400 text-xs" data-id="element-191">
              {purchase.minutesAgo} min fa
            </span>
          </div>
        </div>
      </div>
    </div>;
}